/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from "react";
import { RiMenu2Fill } from "react-icons/ri";
import UserDropdown from "../module/userDropdown";
import { useCurrentuser } from "../../hooks/useUser";
import SearchBar from "../module/search";
import { IoMailUnreadOutline } from "react-icons/io5";
import Notifications from "../module/notifications";
import { useAuth } from "../../controllers/auth";

const Navbar = ({ toggleSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { user } = useAuth();
  // const user = useCurrentuser();
  // const navigate =useNavigate()
  // const handleLogout = () => {
  //   localStorage.removeItem("isAuthenticate");

  //   // navigate("/signin")
  // };

  return (
    <nav className="gap-6 lg:py-6 sm:py-[38px] py-5 capitalize text-base flex md:relative sticky top-0 z-[15]  justify-between items-center dark:bg-dark1 bg-white">
      <ul className="flex items-center gap-4 ">
        <li
          onClick={toggleSidebar}
          className="dark:text-white transition-all duration-300 rounded-full cursor-pointer hover:text-primary"
        >
          <RiMenu2Fill size={20} className="text-lg sm:text-xl" />
        </li>
        <h3 className="font-lato_semibold whitespace-nowrap dark:text-white text-black text-sm sm:text-[16px]">
          <span className="text-[#5C677D] pr-1">Welcome, </span>
          {user?.fullName}
        </h3>
      </ul>
      <div className="lg:block hidden max-w-[450px] 2xl:max-w-[640px] w-full">
        {/* <SearchBar /> */}
      </div>
      <ul className="flex items-center gap-[10px] sm:gap-4 ">
        <li className="text-[#5c677d] rounded-full cursor-pointer">
          <Notifications />
        </li>
        {/* <li className="text-[#5c677d] text-lg   rounded-full cursor-pointer">
          <IoMailUnreadOutline />
        </li> */}
        <li
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          className="relative rounded-full cursor-pointer "
        >
          <UserDropdown />
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
